/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Timeline/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Timeline({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Timeline"
  
}) {
  let isMedia = useIsMedia()
let eventTimelineDateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'timeline_date',
})
let constantData = 'Today'
let aggregateData = fromAggregate.not(eventTimelineDateValueData, constantData)
let eventTimelineDateValueData1 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'timeline_date',
})
  return (<React.Fragment
>
<div
  data-testid="Timeline.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Timeline.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
/>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 style={aggregateData ? "outline" : "filled"}
 size={isMedia.mobile ? "small" : "medium"}
 data="event.timeline_date"
 data="'Today'"
 aggregate="/Simple/Data/aggregate.js not"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="event.timeline_date"
 text={eventTimelineDateValueData1}
/>
)}
</TysiaTag>
<div
  data-testid="Timeline.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
/>
</div>
{children}
</React.Fragment>)
}